import { render } from "./TDDF18_42.vue?vue&type=template&id=52c4f37f&scoped=true"
import script from "./TDDF18_42.vue?vue&type=script&lang=js"
export * from "./TDDF18_42.vue?vue&type=script&lang=js"

import "./TDDF18_42.vue?vue&type=style&index=0&id=52c4f37f&lang=css"
import "./TDDF18_42.vue?vue&type=style&index=1&id=52c4f37f&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\wifigolf\\s_api\\public\\ClpgaApp121\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c4f37f"]])

export default __exports__